"use client";

import { Container } from "@/components/container";
import { Feedback } from "@/components/feedback";
import { useStore } from "@/contexts/store";
import { useEffectOnce } from "@/hooks/use-effect-once";
import { useRouter } from "next/navigation";
import { productAnalitica } from "@/app/(store)/_utils/events";

const NotFoundPage = () => {
  const router = useRouter();
  const { store } = useStore();

  useEffectOnce(() => {
    productAnalitica.events.view.notFound();
  });

  return (
    <Container className="flex min-h-[calc(100vh-232px)] flex-col xl:min-h-[calc(100vh-276px)]">
      <Feedback
        icon="box"
        title="Produto não disponível"
        message="Este produto parece não estar mais no catálogo. Que tal entrar em contato com a loja para saber mais sobre ele?"
        action={{
          text: "Conferir outros produtos",
          icon: "arrow-backward",
          variant: "neutral-ghost",
          onClick: () => {
            productAnalitica.events.action.otherProductsClicked();

            router.push(`/${store.identifier}`);
          },
        }}
      />
    </Container>
  );
};

export default NotFoundPage;
